import React from 'react';
import { Wallet } from 'lucide-react';
import ModulePageLayout, { Section, FeatureGrid, Steps } from '../../components/ModulePageLayout';
import { getModule } from '../../data/modules';

export default function HcaPage() {
  const module = getModule('hca')!;
  return (
    <ModulePageLayout module={module} Icon={Wallet}>
      <Section title="Your Core Banking Hub">
        <p className="text-gray-700 leading-relaxed">
          My Account (HCA) is the financial hub for everything else on Bankably. Every user gets one primary
          account with a unique account number and wallet ID, multi-currency support with FX capability, and
          full double-entry ledger integration behind the scenes.
        </p>
      </Section>

      <Section title="What's Inside">
        <FeatureGrid
          items={[
            { title: 'Up to 7 Savings Sub-Accounts', body: 'Each with its own goal amount, contribution schedule, progress tracking, and tiered interest — pause and resume anytime.' },
            { title: 'AutoStash Round-Ups', body: 'Purchases round up to the nearest dollar; the difference routes to savings, loan repayment, investing, or gifting.' },
            { title: 'Microcredit', body: 'Opt in for a small revolving credit line that adjusts in real time based on your account activity and score.' },
            { title: 'Send Money', body: 'Send directly to other Bankably users by phone, email, or username — with recent recipients, QR scanning, and biometric confirmation.' },
            { title: 'Direct Deposit & Joint Accounts', body: 'Route payroll directly to your HCA, or share an account with full independent authentication for both holders.' },
            { title: 'Linked Deposit Methods', body: 'Connect bank accounts, cards, or crypto wallets as funding sources, with one set as default.' },
          ]}
        />
      </Section>

      <Section title="How a Transaction Flows">
        <Steps
          items={[
            'You initiate a deposit, withdrawal, transfer, or send-money action from the app.',
            'The transaction is recorded with type, amount, currency, and status — pending, completed, failed, or reversed.',
            'If round-up savings is enabled, the spare change is calculated and routed to your chosen destination.',
            'Every movement posts a corresponding entry to your ledger account for full double-entry bookkeeping.',
          ]}
        />
      </Section>
    </ModulePageLayout>
  );
}
